import { logWrapper } from '../../utils';
import swal from 'sweetalert2';

export default {
  nfeModalController: [
    'runtimeConstant',
    '$scope',
    'validationService',
    'authService',
    'webApiSettings',
    'FileUploader',
    'treeService',
    '$filter',
    'service2',
    '$uibModalInstance',
    'ETreeItemTypes',
    function (
      runtimeConstant,
      $scope,
      validationService,
      authService,
      webApiSettings,
      FileUploader,
      treeService,
      $filter,
      service2,
      $uibModalInstance,
      ETreeItemTypes
    ) {
      'use strict';

      var authData = authService.authentication;
      var isauth = authData.token !== null && authData.token !== '';
      var uploader = ($scope.uploader = new FileUploader({
        url: webApiSettings.apiServiceBaseUri + 'companies/new',
        removeAfterUploading: true,
        headers: {
          Authorization: isauth ? 'Bearer ' + authData.token : '',
        },
      }));

      function init() {
        $scope.getCompanie();
      }

      function submit(company) {
        $scope.loading = false;
        var validateCNPJ = validationService.validateCNPJ(company.cnpj);
        if (validateCNPJ) {
          swal.fire({
            title: 'Salvando...',
            text: `Salvando a filial \'${$scope.selectedFolder.Name}\'`,
            showConfirmButton: false,
            allowEscapeKey: false,
            closeOnClickOutside: false,
            allowOutsideClick: false,
            onOpen: function () {
              swal.showLoading();
            },
          });
          swal.showLoading();

          service2.save(company).then(
            function () {
              $uibModalInstance.close();
              swal.close();
              $scope.loading = false;
            },
            function (error) {
              swal.fire({
                title: error.title,
                text: error.text,
                showCancelButton: false,
                confirmButtonText: $filter('translate')('OK'),
              });
              $scope.loading = false;
            }
          );
        } else {
          swal.fire({
            title: 'Erro',
            text: 'CNPJ invalido, favor conferir o numero digitado.',
            showCancelButton: false,
            confirmButtonText: $filter('translate')('OK'),
          });
        }
      }

      function onSeletedFile(event, args) {
        $scope.$apply(function () {
          //add the file object to the scope's files collection
          $scope.files.push(args.file);
        });
      }

      function uploader_onAfterAddingFile(fileItem) {
        $scope.fileName = fileItem.file.name;
      }

      function getCompanie() {
        service2.getCompanie().then(
          function () {
            $scope.companie = service2.onCompanie();

            $scope.loading = false;
          },
          function (error) {
            swal.fire({
              title: error.title,
              text: error.text,
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
            $scope.loading = false;
          }
        );
      }

      function subimitCertified(companie) {
        var extn = $scope.fileName.split('.').pop();

        if (angular.equals('pfx', extn)) {
          if (uploader.queue.length > 0) {
            var item = uploader.queue;

            item[0].formData = [
              {
                company: angular.toJson(companie),
              },
            ];

            item[0].upload();
            $uibModalInstance.close();
            swal.close();
            $scope.loading = false;
          } else {
            swal.fire({
              title: 'Erro',
              text: 'Favor selecionar o certificado',
              showCancelButton: false,
              confirmButtonText: $filter('translate')('OK'),
            });
          }
        } else {
          swal.fire({
            title: 'Certificado',
            text: 'Formato do certificado invalido',
            showCancelButton: false,
            confirmButtonText: $filter('translate')('OK'),
          });
        }
      }

      function canSelectFolder(item) {
        if (item.TreeItemType === ETreeItemTypes.FOLDER) {
          $scope.company.idFolder = item.Id;
        }
        $scope.selectedFolder = item;
        $scope.AllFolderIsSelected = false;
        return false;
      }

      function loadFolders() {
        treeService.getRepositories(true).then(
          function (data) {
            $scope.folders = data;
          },
          function () {
            swal.fire({
              title: 'Erro ao carregar pastas',
              text: 'Tivemos um problema ao carregar suas pastas, por favor recarrege a página',
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: function () {
                return new Promise(function (resolve) {
                  $scope.loadFolders();
                  resolve();
                });
              },
            });
          }
        );
      }

      function expandFolder(folder, e) {
        if (e !== null) {
          e.stopPropagation();
        }

        if (folder.isOpen === null) {
          folder.isOpen = true;
        } else {
          folder.isOpen = !folder.isOpen;
        }

        var isAllFolders = function (c) {
          return c.TreeItemType !== ETreeItemTypes.LOADING;
        };

        var notEmpty =
          folder.children !== undefined && folder.children !== null;

        if (
          folder.HasChildren === false ||
          (notEmpty && folder.children.every(isAllFolders))
        ) {
          return;
        }

        if (folder.children === undefined || folder.children === null) {
          folder.children = [];
        }

        var anyFolder = folder.children.some(function (c) {
          return c.TreeItemType === ETreeItemTypes.LOADING;
        });

        if (!anyFolder) {
          folder.children.push(treeService.loadingItem);
        }

        treeService.getChildren(folder).then(
          function (data) {
            data = data.filter(function (f) {
              return f.Id !== $scope.idFolderNotShow;
            });

            folder.children.forEach(function (c) {
              if (!c) {
                folder.children.splice(folder.children.indexOf(c), 1);
              } else {
                var f = folder.children.filter(function (e) {
                  return e.Id === c.Id;
                });
                if (f && f.length > 1) {
                  f.forEach(function (remove) {
                    folder.children.splice(folder.children.indexOf(remove), 1);
                  });
                }
              }
            });
            folder.children.splice(
              folder.children.indexOf(treeService.loadingItem),
              1
            );

            data.forEach(function (d) {
              //remover o item undefined
              if (
                !folder.children.some(function (c) {
                  //se não for campo adicional ou tipo de documento vai remover os itens que tem id duplicado
                  return (
                    c &&
                    c.TreeItemType !== ETreeItemTypes.DOCUMENT_TYPE &&
                    c.TreeItemType !== ETreeItemTypes.ADDITIONAL_FIELD &&
                    c.Id === d.Id
                  );
                })
              ) {
                folder.children.push(d);
              }
            });

            folder.children = $filter('orderBy')(folder.children, [
              '+TreeItemType',
              '+Name',
            ]);
          },
          function () {
            swal.fire({
              title: $filter('translate')('CHILDREN LOAD ERROR'),
              text: $filter('translate')('CHILDREN LOAD ERROR MSG'),
              icon: 'error',
              showCancelButton: true,
              confirmButtonColor: '#DD6B55',
              confirmButtonText: $filter('translate')('RETRY'),
              showLoaderOnConfirm: true,
              preConfirm: function () {
                return new Promise(function (resolve) {
                  $scope.expandFolder(folder, e);
                  resolve();
                });
              },
            });
          }
        );

        $scope.getItemIcon = function (item) {
          // icons: repository, folder, doctype, additionalFields
          var icons = [
            'md-repository',
            'md-doc-folder',
            'md-doc-type',
            'md-add-fields',
            'md-loading',
          ];

          // icons: repositorio e pasta desabilitados
          var disabledIcons = [
            'md-repository-disabled',
            'md-folder-disabled',
            'md-doc-type',
            'md-add-fields',
            'md-loading',
          ];

          // icons: quickaccess, shared docs, none, checkuot, none, favoritos
          var quickAcess = [
            'md-alarm',
            'md-share',
            '',
            'md-file-download',
            '',
            'md-grade',
          ];

          if (item.TreeItemType > 4) {
            //Os icons são de 5 a 10, então remove cinco pra ficar certo o indice do array
            return quickAcess[item.TreeItemType - 5];
          }

          if (item.HasPermission) {
            //Retorna os icones habilitados
            return icons[item.TreeItemType];
          } else {
            return disabledIcons[item.TreeItemType];
          }
        };

        $scope.expandFolder = function (folder, e) {
          // Evita que o envento click se propague para os filhos. Ex( a.li.ul.span.a =  a -> li -> ul -> span)
          if (e !== null) {
            e.stopPropagation();
          }

          if (folder.isOpen === null) {
            folder.isOpen = true;
          } else {
            folder.isOpen = !folder.isOpen;
          }

          var isAllFolders = function (c) {
            return c.TreeItemType !== ETreeItemTypes.LOADING;
          };

          var notEmpty =
            folder.children !== undefined && folder.children !== null;

          if (
            folder.HasChildren === false ||
            (notEmpty && folder.children.every(isAllFolders))
          ) {
            return;
          }

          if (folder.children === undefined || folder.children === null) {
            folder.children = [];
          }

          var anyFolder = folder.children.some(function (c) {
            return c.TreeItemType === ETreeItemTypes.LOADING;
          });

          if (!anyFolder) {
            folder.children.push(treeService.loadingItem);
          }

          treeService.getChildren(folder).then(
            function (data) {
              data = data.filter(function (f) {
                return f.Id !== $scope.idFolderNotShow;
              });

              folder.children.forEach(function (c) {
                if (!c) {
                  folder.children.splice(folder.children.indexOf(c), 1);
                } else {
                  var f = folder.children.filter(function (e) {
                    return e.Id === c.Id;
                  });
                  if (f && f.length > 1) {
                    f.forEach(function (remove) {
                      folder.children.splice(
                        folder.children.indexOf(remove),
                        1
                      );
                    });
                  }
                }
              });
              folder.children.splice(
                folder.children.indexOf(treeService.loadingItem),
                1
              );

              data.forEach(function (d) {
                //remover o item undefined
                if (
                  !folder.children.some(function (c) {
                    //se não for campo adicional ou tipo de documento vai remover os itens que tem id duplicado
                    return (
                      c &&
                      c.TreeItemType !== ETreeItemTypes.DOCUMENT_TYPE &&
                      c.TreeItemType !== ETreeItemTypes.ADDITIONAL_FIELD &&
                      c.Id === d.Id
                    );
                  })
                ) {
                  folder.children.push(d);
                }
              });

              folder.children = $filter('orderBy')(folder.children, [
                '+TreeItemType',
                '+Name',
              ]);
            },
            function () {
              swal.fire({
                title: $filter('translate')('CHILDREN LOAD ERROR'),
                text: $filter('translate')('CHILDREN LOAD ERROR MSG'),
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: $filter('translate')('RETRY'),
                showLoaderOnConfirm: true,
                preConfirm: function () {
                  return new Promise(function (resolve) {
                    $scope.expandFolder(folder, e);
                    resolve();
                  });
                },
              });
            }
          );
        };
      }

      function run() {
        try {
          $scope.company = {};
          $scope.certificado = {};
          $scope.files = [];
          $scope.companie = {};
          $scope.folders = null;
          $scope.uploadedFiles = [];
          $scope.fileName = '';

          $scope.$on(
            'seletedFile',
            logWrapper(
              onSeletedFile,
              runtimeConstant.isDebugControllersInternals
            )
          );
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.submit = logWrapper(
            submit,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.uploader.onAfterAddingFile = logWrapper(
            uploader_onAfterAddingFile,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getCompanie = logWrapper(
            getCompanie,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.subimitCertified = logWrapper(
            subimitCertified,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.canSelectFolder = logWrapper(
            canSelectFolder,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadFolders = logWrapper(
            loadFolders,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.expandFolder = logWrapper(
            expandFolder,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
